import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ThemeService } from './core/preferences/theme.service';
import { TranslationService } from './core/i18n/translation.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  // Injected (not used directly) so its constructor -- which applies the persisted/OS
  // dark-mode preference to <html> -- runs once at bootstrap, before any route renders.
  private readonly themeService = inject(ThemeService);

  // Same reasoning as themeService above: applies the persisted language/dir to <html>
  // before any route (including the unauthenticated login page) renders.
  private readonly translationService = inject(TranslationService);
}
